import React from 'react';

import { Send as SendIcon } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

import { Field, Form, FormApi } from '@hrlogics/react-components/form';

import { TextField } from 'src/components/finalForm';

import { FormField } from './constants';
import { FormValues } from './types';
import { formValidationSchema } from './validation';

type EmployeeDataInternalNotesCardProps = {
  onCreate: (comment: string) => void | Promise<void>;
};

export const EmployeeDataInternalNotesCardForm: React.FC<EmployeeDataInternalNotesCardProps> = ({
  onCreate,
}) => {
  const handleSubmit = React.useCallback(
    async (formValues: FormValues, formApi: FormApi<FormValues>) => {
      await onCreate(formValues.comment);
      formApi.restart(initialValues);
    },
    [onCreate],
  );

  return (
    <Form<FormValues>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      subscription={{ submitting: true, valid: true }}
      validationSchema={formValidationSchema}
    >
      {({ submitting, valid }) => (
        <React.Fragment>
          <Field
            name={FormField.comment}
            component={TextField}
            placeholder="Leave a note about this user that will only be visible to platform admins"
            label="New Employee Note"
            rows={2}
            multiline
            fullWidth
            disabled={submitting}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      type="submit"
                      title="Save note"
                      disabled={!valid}
                      loading={submitting}
                      edge="end"
                    >
                      <SendIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </React.Fragment>
      )}
    </Form>
  );
};

const initialValues: FormValues = {
  comment: '',
};
